import Api from './Api'
import {store} from '../store/store.js'
import axios from 'axios'
import router from '../../router'

/**
 * @typedef {Rest}
 */
export default class Rest extends Api {
  /**
   * @type {String}
   */
  static resource = ''

  /**
   * @type {String}
   */
  id = 'id'

  /**
   * @param {String} resource
   * @param {Object} options
   * @param {Object} http
   */
  constructor (resource, options = {}, http = null) {
    //super(Rest.normalize(Rest.base, resource), options, http)
    console.log('está logado?', store.getters.is_loggedin)
    if(store.getters.is_loggedin){      
      //@todo criar um axios create único para centralizar 
      var _http =  axios.create({
        baseURL: process.env.VUE_APP_BASE_URL,
        timeout: 100000,
        transformResponse: [
          function (data) {            
            if(data.error_code){
              store.commit('token', false);
              router.push({name:'login'});
            }
            return data;
          }
        ],
        responseType: 'json',  
        headers: {
            'Authorization':'Bearer '+store.getters.token,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json'      
          }
      })
      super(Rest.normalize(Rest.base, resource), options, _http)
    }else{
      super(Rest.normalize(Rest.base, resource), options, http)
    }
  }

  /**
   * @return {this}
   */
  static build () {
    return new this(this.resource)
  }

  /**
   * @param {Object} record
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  create (record) {
    return this.post('', record)
  }

  /**
   * @param {String|Object} record
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  read (record) {
    return this.get(`/${this.getId(record)}`)
  }

  /**
   * @param {Object} record
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  update (record) {
    return this.patch(`/${this.getId(record)}`, record)
  }

  /**
   * @param {Object} record
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  destroy (record) {
    return this.delete(`/${this.getId(record)}`)
  }

  /**
   * @param {Object} parameters
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  search (parameters = {}) {
    const queryString = ''
    // apply your logic here
    return this.get(`?${queryString}`).then(response => ({
      items: response.items // just an example
    }))
  }

  /**
   * @param {String|Object} record
   * @returns {String}
   */
  getId (record) {
    if (typeof record === 'object') {
      return record[this.id]
    }
    return String(record)
  }
}